import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Drawer } from '@root/shared/ui-kit'

import { TradeSettingsPresetForm } from '../../desktop/ui/trade-settings-preset-form'

import type { TradeSettingsFormProps } from '../../desktop/ui/trade-settings-preset-form'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'onOpenChange' | 'open'> & TradeSettingsFormProps

export const TradeSettingsDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  onSaved,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Root
        open={open}
        onOpenChange={onOpenChange}
        title={t('trade_settings')}
        fixed={false}
        repositionInputs={false}
      >
        <Content>
          <TradeSettingsPresetForm
            onSaved={(settings) => {
              onSaved?.(settings)
              onOpenChange?.(false)
            }}
          />
        </Content>
      </Root>
    </>
  )
}

const Root = styled(Drawer)`
  height: auto;
`

const Content = styled.div`
  display: grid;
  padding-bottom: var(--safe-area-inset-bottom);
  min-width: 0;
`
